import { Feature } from 'geojson';
import { millisecondsInOneDay } from '../shared/constants';
import { convertDecimalToDM } from './location';

// Returns a date string on this format YYYY-MM-DD
export const getDateISOString = (dateObject: Date) => dateObject.toISOString().slice(0, 10);

export const isValidDateString = (input: string): boolean => {
    const test = new Date(input);
    return !isNaN(test.getTime());
};

export const findIndexOfDateInArray = (dateArray: Date[], queryDate: Date): number => {
    const tempDateDiffs = dateArray.map((d) => Math.abs(queryDate.getTime() - d.getTime())); // Get time difference to all datobjects
    const closestDateIndex = tempDateDiffs.indexOf(Math.min(...tempDateDiffs)); // Get index of smallest timedifference
    return closestDateIndex;
};

export const formatLatLonText = (selectedFeature: Feature | null): string | null => {
    if (
        selectedFeature &&
        selectedFeature.properties &&
        selectedFeature.properties.lat &&
        selectedFeature.properties.lon
    ) {
        const round_lat = Math.round(selectedFeature?.properties?.lat * 100000000) / 100000000;
        const round_lon = Math.round(selectedFeature?.properties?.lon * 100000000) / 100000000;
        return round_lat.toString() + ',' + round_lon.toString();
    }
    return null;
};
export const formatLatLonDMText = (selectedFeature: Feature | null): string | null => {
    if (
        selectedFeature &&
        selectedFeature.properties &&
        selectedFeature.properties.lat &&
        selectedFeature.properties.lon
    ) {
        const lat = selectedFeature?.properties?.lat;
        const lon = selectedFeature?.properties?.lon;
        return convertDecimalToDM(lat, lon);
    }
    return null;
};

export const getDateTimeText = (timestamp: Date): string => {
    // Give relative time difference if time diff is low
    const diffHours = (new Date().getTime() - timestamp.getTime()) / (1000 * 60 * 60);
    if (diffHours < 8) {
        return `${Math.floor(diffHours)} h and ${Math.floor((diffHours - Math.floor(diffHours)) * 60)} min ago`;
    }
    return timestamp.toUTCString().split(' ')[4] + ' GMT';
};

export const isDateIntervalWithinGivenDays = (startDate: Date, endDate: Date, days: number): boolean => {
    return endDate.getTime() - startDate.getTime() < days * millisecondsInOneDay;
};
